import { useState } from "react";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

// ─── Reusable label ───────────────────────────────────────────────────────────

const Label = ({ children }) => (
  <label className="block mb-1.5 text-[0.72rem] font-semibold tracking-[0.08em] uppercase text-[#9C9488]">
    {children}
  </label>
);

// ─── Shared input classes ─────────────────────────────────────────────────────

const INPUT_CLS =
  "w-full h-11 px-4 bg-[#EDE7D9] border border-[#D6CDB8] text-[#1C1A16] text-sm outline-none focus:border-[#C4622D] transition-colors placeholder:text-[#B8B0A0]";

// ─── Component ───────────────────────────────────────────────────────────────

function Contact() {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "", country: "", whatsapp: "", phone: "", email: "", amount: "", complaint: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const setPhone = (field) => (value) =>
    setFormData((prev) => ({ ...prev, [field]: value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post("https://bitsos-backend-123.onrender.com/shieldcrypt", formData);
      if (res.status === 200) {
        toast.success(res.data.status);
        setFormData({ name: "", country: "", whatsapp: "", phone: "", email: "", amount: "", complaint: "" });
      } else {
        toast.error("Failed to submit the form. Please try again.");
      }
    } catch (err) {
      console.error(err);
      toast.error("An error occurred while submitting the form. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-[#F7F3EC] min-h-screen px-8 py-20">
      <div className="max-w-[680px] mx-auto">

        <p className="text-[0.72rem] font-semibold tracking-[0.16em] uppercase text-[#C4622D] mb-4">
          File a Complaint
        </p>
        <h2 className="sc-serif text-[clamp(1.8rem,3vw,2.5rem)] text-[#1C1A16] leading-[1.15] mb-3">
          Complete this form to file a complaint
        </h2>
        <p className="text-[#6B6457] text-[0.9rem] leading-[1.7] mb-12">
          Please provide accurate information so we can review your case properly.
        </p>

        <form onSubmit={handleSubmit} className="flex flex-col gap-6">

          {/* Row 1 – name + email */}
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
            <div>
              <Label>Full Name *</Label>
              <input
                type="text" name="name" required
                placeholder="John Doe"
                value={formData.name} onChange={handleChange}
                className={INPUT_CLS}
              />
            </div>
            <div>
              <Label>Email Address *</Label>
              <input
                type="email" name="email" required
                placeholder="john@example.com"
                value={formData.email} onChange={handleChange}
                className={INPUT_CLS}
              />
            </div>
          </div>

          {/* Row 2 – phone inputs */}
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
            <div>
              <Label>Whatsapp Number *</Label>
              <PhoneInput
                international required
                placeholder="Enter Whatsapp number"
                value={formData.whatsapp}
                onChange={setPhone("whatsapp")}
                className="custom-phone-input"
              />
            </div>
            <div>
              <Label>Phone Number *</Label>
              <PhoneInput
                international required
                placeholder="Enter phone number"
                value={formData.phone}
                onChange={setPhone("phone")}
                className="custom-phone-input"
              />
            </div>
          </div>

          {/* Row 3 – country + amount */}
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
            <div>
              <Label>Country of Residence *</Label>
              <input
                type="text" name="country" required
                placeholder="Enter your country"
                value={formData.country} onChange={handleChange}
                className={INPUT_CLS}
              />
            </div>
            <div>
              <Label>Amount</Label>
              <input
                type="number" name="amount" required
                placeholder="e.g. 50000"
                value={formData.amount} onChange={handleChange}
                className={INPUT_CLS}
              />
            </div>
          </div>

          {/* Complaint textarea */}
          <div>
            <Label>Complaint / Message *</Label>
            <textarea
              name="complaint" rows={6} required
              placeholder="Describe your complaint in detail..."
              value={formData.complaint} onChange={handleChange}
              className="w-full px-4 py-3 bg-[#EDE7D9] border border-[#D6CDB8] text-[#1C1A16] text-sm outline-none focus:border-[#C4622D] transition-colors resize-none placeholder:text-[#B8B0A0]"
            />
          </div>

          {/* Privacy note */}
          <p className="text-[0.8rem] text-[#9C9488] leading-[1.65] border-l-[3px] border-[#C4622D] pl-4">
            Your information is protected with bank-level encryption. We maintain strict confidentiality and never share your details with third parties.
          </p>

          {/* Submit */}
          <button
            type="submit"
            disabled={loading}
            className="w-full py-3.5 bg-[#1C1A16] text-[#F7F3EC] text-sm font-semibold hover:bg-[#C4622D] transition-colors disabled:opacity-50 cursor-pointer border-none"
          >
            {loading ? "Sending..." : "Send Complaint"}
          </button>
        </form>
      </div>

      <ToastContainer />
    </div>
  );
}

export default Contact;